import axios from "axios";
import moment from "moment";
import { User } from "@/models/User";
import { Settings } from "@/models/Settings";
export function apiGet(url) {
    return axios.get(process.env.VUE_APP_ROOT_API + url, { withCredentials: true })
        .then((res) => {
        return res.data.data;
    });
}
// @ts-ignore
window.apiGet = apiGet;
export function apiPost(url, data) {
    return axios.post(process.env.VUE_APP_ROOT_API + url, data, { withCredentials: true });
}
export function me(force = false) {
    // TODO cache
    const cMe = localStorage.getItem("cache_me");
    if (cMe !== null && !force) {
        return Promise.resolve(User.fromJson(JSON.parse(cMe)));
    }
    else {
        return apiGet("/users/me").then((json) => {
            localStorage.setItem("cache_me", JSON.stringify(json));
            return User.fromJson(json);
        });
    }
}
export function getConfig() {
    return apiGet("/settings").then((sqlObj) => {
        const s = new Settings();
        s.firstTee = moment(sqlObj.firstTeeoff, "H");
        s.lastTee = moment(sqlObj.lastTeeoff, "H");
        s.cooldown = moment.duration(parseInt(sqlObj.cooldown, 10), "minutes");
        s.granularity = moment.duration(parseInt(sqlObj.granularity, 10), "minutes");
        s.authExpires = moment.duration(parseInt(sqlObj.authExpires, 10), "minutes");
        s.authStale = moment.duration(parseInt(sqlObj.authStale, 10), "minutes");
        return s;
    });
}
export function verifyAuth(redirLogin = true) {
    // has auth
    const refresh = localStorage.getItem("auth_expires");
    const token = localStorage.getItem("auth_xsrf");
    if (refresh !== null && refresh !== undefined && token !== null && token !== undefined) {
        const stale = moment(refresh);
        const now = moment();
        if (now.isBefore(stale)) {
            return true;
        }
    }
    if (redirLogin) {
        const exPath = encodeURIComponent(window.location.pathname);
        window.location = ("/login/?from=" + exPath);
    }
    return false;
}
//# sourceMappingURL=session.js.map